import { List, MediaType } from '@epicuro-next/models/engagement';

import { isCommercialList } from './is-list-of-type';

export function isEpicShow(list?: List) {
  return list?.mainMedia?.mediaType === MediaType.Directshow;
}

export function isVideoMedia(list?: List) {
  return Boolean(
    list?.mainMedia?.mediaType === MediaType.Video ||
      list?.mainMedia?.mediaType === MediaType.Directshow,
  );
}

export function shouldShowListHeader(list?: List) {
  return list ? !isCommercialList(list) : undefined;
}

export function shouldShowListBanner(list?: List) {
  return list ? isCommercialList(list) : undefined;
}
